<template>
    <t-layout>
        <!--侧边菜单-->
        <t-aside>
            <t-menu
                theme="dark"
                default="2-1"
                height="100%"
                :collapsed="collapsed"
                :value="activeMenu"
                @change="menuChange"
            >

              <!--logo-->
              <template #logo>
                  <img height="48" :src=logoImg alt="logo"/>
                  <span class="system-name">管理后台</span>
              </template>

              <!--侧边菜单-->
              <t-menu-item value="home">
                  <template #icon>
                      <t-icon name="home" />
                  </template>
                  首页
              </t-menu-item>

              <t-submenu value="camp">
                  <template #icon>
                      <t-icon name="laptop" />
                  </template>
                  <template #title>
                    <span>营地管理</span>
                  </template>
                  <t-menu-item value="campAdmin"> 营地管理 </t-menu-item>
                  <t-menu-item value="campRate"> 营地评价 </t-menu-item>
              </t-submenu>

              <t-submenu value="operation">
                  <template #icon>
                    <t-icon name="control-platform" />
                  </template>
                  <template #title>
                    <span>运营管理</span>
                  </template>
                  <t-menu-item value="homeAdmin"> 首页管理 </t-menu-item>
                  <t-menu-item value="searchAdmin"> 搜索管理 </t-menu-item>
                  <t-menu-item value="categoryAdmin"> 分类页管理 </t-menu-item>
              </t-submenu>

              <t-submenu value="user">
                  <template #icon>
                    <t-icon name="user" />
                  </template>
                  <template #title>
                    <span>用户管理</span>
                  </template>
                  <t-menu-item value="userAdmin"> 用户管理 </t-menu-item>
              </t-submenu>

              <t-submenu value="setting">
                  <template #icon>
                    <t-icon name="setting" />
                  </template>
                  <template #title>
                    <span>系统管理</span>
                  </template>

                  <t-menu-item value="accountAdmin"> 账号管理 </t-menu-item>
                  <t-menu-item value="facilityAdmin"> 设施管理 </t-menu-item>
                  <t-menu-item value="labelAdmin"> 标签管理 </t-menu-item>
                  <t-menu-item value="AgreementAdmin"> 服务协议管理 </t-menu-item>
                  <t-menu-item value="setAdmin"> 系统设置 </t-menu-item>

              </t-submenu>

            </t-menu>
        </t-aside>

        <!--右侧内容区-->
        <t-layout>

             <!--顶部导航栏-->
            <div class="header-nav">
                <div class="user-info">
                  <t-dropdown :options="[{ content: '退出登录', value: 'logout' }]" @click="handleDropdownClick">
                      <t-button variant="text">
                          <span>{{ userName }}</span>
                          <template #suffix> <t-icon name="chevron-down" size="14" /></template>
                      </t-button>
                  </t-dropdown>
              </div>
            </div>

            <!--面包屑-->
            <t-breadcrumb :maxItemWidth="'150'">
              <t-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index" :to="item.path">
                {{ item.title }}
              </t-breadcrumb-item>
            </t-breadcrumb>

            <!--内容区域-->
            <div class="main-content">
                  <router-view></router-view>
            </div>
        </t-layout>
    </t-layout>

</template>


<script setup>
    import { ref,watch,onMounted} from 'vue';
    import { useRouter,useRoute} from 'vue-router';
    import { MessagePlugin } from 'tdesign-vue-next';
    import authAPI from '../../api/auth-api.js'; 
    
    //logo地址
    const logoImg='https://yequ-1331262631.cos.ap-nanjing.myqcloud.com/logo/logo.png';

    //菜单选择
    const collapsed = ref(false);
    const changeCollapsed = () => {
        collapsed.value = !collapsed.value;
    };

    //菜单路由
    const router = useRouter();
    const route = useRoute();
    const activeMenu = ref(route.path);
    const breadcrumbs = ref([]);

    const routeMap = {
        home: { path: '/', title: '首页' },
        //营地管理
        campAdmin: { path: '/camp/camp-admin', title: '营地管理' },
        campDetail: { path: '/camp/camp-detail/:id', title: '营地详情' , parent: 'campAdmin' },
        campAdd: { path: '/camp/camp-add', title: '新增营地', parent: 'campAdmin'  },
        campEdit: { path: '/camp/camp-edit/:id', title: '编辑营地' , parent: 'campAdmin' },
        campRate: { path: '/camp/camp-rate', title: '营地评价' },
        //运营管理
        homeAdmin: { path: '/operation/home-admin', title: '首页管理' },
        searchAdmin: { path: '/operation/search-admin', title: '搜索管理' },
        categoryAdmin: { path: '/operation/category-admin', title: '分类页管理' },
        //用户管理
        userAdmin: { path: '/user/user-admin', title: '用户管理' },
        userDetail: { path: '/user/user-detail/:id', title: '用户详情' , parent: 'userAdmin' },
        //设置
        accountAdmin: { path: '/set/account-admin', title: '账号管理' },
        labelAdmin: { path: '/set/label-admin', title: '标签管理' },
        facilityAdmin: { path: '/set/facility-admin', title: '设施管理' },
    };

    const menuChange = (value) => {
        activeMenu.value = value;

        if (routeMap[value]) {
          router.push(routeMap[value].path);
        } else {
          router.push('/');
        }
    };

    const userName = ref('');

    // 获取用户信息的函数
    const getUserInfo = async () => {
        try {
            const response = await authAPI.getCurrentUser();
            if (response && typeof response === 'object' && 'username' in response) {
              userName.value = response.username;
            } else {
              MessagePlugin.error('获取用户信息失败：unexpected response structure');
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
              MessagePlugin.error('会话已过期，请重新登录');
              router.push({ name: 'login' });
            } else {
              MessagePlugin.error('获取用户信息失败');
            }
        }
    };

// 退出登录函数
const logout = async () => {
  try {
    await authAPI.logout();
    localStorage.removeItem('token');  // 删除存储的 token
    MessagePlugin.success('已退出登录');
    router.push({ name: 'login' });
  } catch (error) {
    MessagePlugin.error('退出登录失败');
  }
};

// 处理下拉菜单点击
const handleDropdownClick = (data) => {
  if (data.value === 'logout') {
    logout();
  }
};

onMounted(() => {
  const token = localStorage.getItem('token');
  if (token) {
    authAPI.setAuthToken(token);
    getUserInfo();
  } else {
    // 如果没有 token，重定向到登录页面
    router.push({ name: 'login' });
  }
});

    // 更新面包屑
    const updateBreadcrumbs = (path) => {
        const currentRoute = Object.entries(routeMap).find(([key, route]) => {
            const routeRegex = new RegExp('^' + route.path.replace(/:\w+/g, '[^/]+') + '$');
            return routeRegex.test(path);
        });
        
        if (currentRoute) {
            const [key, route] = currentRoute;
            breadcrumbs.value = [];
          
          if (route.parent) {
            const parentRoute = routeMap[route.parent];
            breadcrumbs.value.push({ title: parentRoute.title, path: parentRoute.path });
            breadcrumbs.value.push({ title: route.title, path: route.path });
          } else {
              // 如果是一级菜单，只显示当前路由
              breadcrumbs.value.push({ title: route.title, path: route.path });
          }
          } else {
              // 如果没有找到匹配的路由，使用空的面包屑
              breadcrumbs.value = [];
          }
  };

    // 监听路由变化
    watch(() => route.fullPath, (newPath) => {
        updateBreadcrumbs(newPath);
    }, { immediate: true });

    // 面包屑导航
    const navigateTo = (path) => {
      router.push(path);
    };

</script>


<!--样式-->
<style>
  @import "./layout.css";
</style>
